/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationSlotTime200ResponseSlotTime
 */
export interface GetReservationSlotTime200ResponseSlotTime {
}

/**
 * Check if a given object implements the GetReservationSlotTime200ResponseSlotTime interface.
 */
export function instanceOfGetReservationSlotTime200ResponseSlotTime(value: object): value is GetReservationSlotTime200ResponseSlotTime {
    return true;
}

export function GetReservationSlotTime200ResponseSlotTimeFromJSON(json: any): GetReservationSlotTime200ResponseSlotTime {
    return GetReservationSlotTime200ResponseSlotTimeFromJSONTyped(json, false);
}

export function GetReservationSlotTime200ResponseSlotTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationSlotTime200ResponseSlotTime {
    return json;
}

export function GetReservationSlotTime200ResponseSlotTimeToJSON(json: any): GetReservationSlotTime200ResponseSlotTime {
    return GetReservationSlotTime200ResponseSlotTimeToJSONTyped(json, false);
}

export function GetReservationSlotTime200ResponseSlotTimeToJSONTyped(value?: GetReservationSlotTime200ResponseSlotTime | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

